<!-- ── Hero ── -->
<section class="hero">
  <div class="hero-inner">
    <div class="hero-left">
      <h1>Projects<span class="hero-company" *ngIf="company"> — {{ company }}</span></h1>
      <p class="hero-sub">Manage and select your active projects</p>
    </div>
    <div class="hero-right">
      <div class="hero-kpi">
        <mat-icon>folder_open</mat-icon>
        <div class="kpi-text">
          <span class="kpi-value">{{ projects.length }}</span>
          <span class="kpi-label">Total</span>
        </div>
      </div>
      <div class="hero-kpi active" *ngIf="selectedProjectNumber">
        <mat-icon>check_circle</mat-icon>
        <div class="kpi-text">
          <span class="kpi-value">#{{ selectedProjectNumber }}</span>
          <span class="kpi-label">Active</span>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="project-shell">

  <!-- Alerts -->
  <div *ngIf="loading" class="status-bar loading">
    <mat-icon>hourglass_empty</mat-icon> Loading projects…
  </div>
  <div *ngIf="error" class="status-bar error">
    <mat-icon>error</mat-icon> {{ error }}
  </div>

  <!-- Toolbar row: search + create button -->
  <div class="toolbar" *ngIf="!loading && projects.length > 0">
    <div class="search-box">
      <mat-icon class="search-icon">search</mat-icon>
      <input type="text" [(ngModel)]="searchTerm" placeholder="Search by name, number, or manager…" />
      <button class="search-clear" *ngIf="searchTerm" (click)="searchTerm = ''" matTooltip="Clear search">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <a class="btn-create" routerLink="/projects/create" *ngIf="canCreateProject()">
      <mat-icon>add</mat-icon> New Project
    </a>
  </div>

  <!-- Empty search state -->
  <div class="empty-state" *ngIf="!loading && projects.length > 0 && filteredProjects.length === 0">
    <mat-icon>search_off</mat-icon>
    <p>No projects match "<strong>{{ searchTerm }}</strong>"</p>
  </div>

  <!-- Table Card -->
  <div class="card" *ngIf="filteredProjects.length > 0">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th class="col-num">#</th>
            <th>Project Name</th>
            <th>DeSimone Manager</th>
            <th>{{ company ? company + ' Manager' : 'Outsource Manager' }}</th>
            <th>Created</th>
            <th>Updated</th>
            <th class="col-status">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let project of filteredProjects"
              [class.selected]="selectedProjectNumber === project.projectNumber"
              (click)="selectProject(project.projectNumber)">
            <td class="cell-num">{{ project.projectNumber }}</td>
            <td class="cell-name">{{ project.projectName }}</td>
            <td class="cell-pm">
              <span class="pm-badge">
                <mat-icon>person</mat-icon>{{ project.pm }}
              </span>
            </td>
            <td class="cell-pm">
              <span class="pm-badge" *ngIf="project.outsourcePm">
                <mat-icon>person_outline</mat-icon>{{ project.outsourcePm }}
              </span>
              <span *ngIf="!project.outsourcePm">—</span>
            </td>
            <td class="cell-date">{{ project.dateCreated | date: 'MMM dd, yyyy' }}</td>
            <td class="cell-date">{{ project.dateUpdated | date: 'MMM dd, yyyy' }}</td>
            <td class="cell-status">
              <span class="status-dot" [class.active]="selectedProjectNumber === project.projectNumber"></span>
              {{ selectedProjectNumber === project.projectNumber ? 'Active' : '—' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Footer hint -->
  <p class="footer-hint" *ngIf="filteredProjects.length > 0">
    <mat-icon>touch_app</mat-icon> Click any row to set it as your active project
  </p>

</div>